export enum AutocompleteMobileType {
  FULL = 'full',
  SMALL = 'small',
  FAKE_INPUT = 'fake-input'
}